import i18n from "@i18n";

import { appConfig } from "src/config";

export const loginLink =
  appConfig.NOOM_ENV === "production"
    ? i18n.t("navigation:loginLink")
    : i18n.t("navigation:loginLinkDev");
